import React from "react";
import "../Dashboard/Dashboard.css";
import { toast } from "react-toastify";
import axiosinstances from "../../Helper/useAxios";
import { isSuperAdmin, isUserAdmin } from "../../utils/comman/Common";
import { useSelector } from "react-redux";
import { useState } from "react";
import { useEffect } from "react";
import { Loadbalance } from "../Model/Loadbalance";


const Escrow = () => {
  const [axiosInstance] = axiosinstances()
  const [loadingData, setLoadingData] = useState(false);
  const [balance, setBalance] = useState('Escrow Balance')
  const [showModal, setShowModel] = useState(false)
  const [otp, setOtp] = useState('');
  const [amount, setAmount] = useState('')
  const id = useSelector((state) => state.getprofilereducer?.getprofile?.id);
  const e = JSON.parse(sessionStorage.getItem("token"));
useEffect(() => {
    fetchBalance(id)

}, [])

const fetchBalance = async (id) => {
    setLoadingData(true);
    const response = await axiosInstance
      .get(`api/v1/dmt/escrow/balance`, {
        headers: {
          Authorization: `Bearer ${e}`,
          "client-id": id,
          role: "ROLE_RETAILER_FINXPAY",
        },
      })
      .then((res) => {
        setLoadingData(false);
        //console.log("res", res)
        setBalance(res?.data)
        return res;
      })
      .catch((err) => {
        //console.log(err);
        setLoadingData(false);
        toast.error("Facing Problem to fetching balance");
      });
    if (response) {
      const result = response.data.orders;

      if (result) {
      }

      return response.data;
    }
    return false;
  };

 const closePopUp = () =>{
    setShowModel(false)
 }
 
 const sendotpHandler = async () => {
    // setLoadingData(true);
    const response = await axiosInstance
      .get(`api/v1/dmt/escrow/admin/otp`, {
        headers: {
          Authorization: `Bearer ${e}`,
          "client-id": id,
          role: "ROLE_RETAILER_FINXPAY",
        },
      })
      .then((res) => {
        
        //console.log("sending otp", res)
        setShowModel(true)
        toast.success("OTP send Successfully");
      })
      .catch((err) => {
        //console.log(err);
        // setLoadingData(false);
        toast.error("Facing Problem to sending OTP");
      });
    if (response) {
      const result = response.data.orders;

      if (result) {
      }

      return response.data;
    }
    return false;
  };

 const updateBalance = async () => {
    
    
    const response = await axiosInstance
      .get(`api/v1/dmt/escrow/credit/${otp}/${amount}`, {
        headers: {
          Authorization: `Bearer ${e}`,
          "client-id": id,
          role: "ROLE_RETAILER_FINXPAY",
        },
      })
      .then((res) => {
        
        //console.log("update balance", res)
        // setBalance(res?.data)
        setShowModel(false)
        fetchBalance(id)
        return res;
      })
      .catch((err) => {
        //console.log(err);
        
        toast.error("Facing Problem to fetching balance");
      });
   
  };
  return (
    <React.Fragment>
    <Loadbalance
    showModal={showModal}
    closePopUp={closePopUp}
    otp={otp}
    setOtp={setOtp}
    amount={amount}
    setAmount={setAmount}
    updateBalance={updateBalance}
    sendotpHandler={sendotpHandler}
    />
   {
   isSuperAdmin(id) && isUserAdmin(id) && 
   
      <div class="mid">
        <div class="container-fluid">
          <div class="maincard">
            <div class="tab-content" id="mobiletab">
              <div
                class="tab-pane fade show active"
                id="nav-mobi"
                role="tabpanel"
                aria-labelledby="mobile-tab"
              >
                <div class="head">
                  <h3>Escrow Dashboard</h3>
                  <button class="btn" type="button" onClick={sendotpHandler}>Load Balance</button>
                </div>
                
                <div class="txn-list" id="recntxn">
                <h6> {loadingData ? 
                          <div class="spinner-border ml-4" role="status">
                            <span class="sr-only">Loading...</span>
                          </div> 
                         : balance}</h6>
                </div>
              </div>
             
              <div
                class="tab-pane fade"
                id="mobi-grap"
                role="tabpanel"
                aria-labelledby="mobi-grap-tab"
              >
                {/* <TransactionGraph/>  */}
              </div>
            </div>
          </div>
        </div>
      </div>
}
    </React.Fragment>
  );
};

export default Escrow;
